module.exports = __webpack_public_path__ + "img/tabicon1.d1c07695.png";